import React, { useState } from "react";

export function NavConversion({ handleTabChange }) {
    const [activeTab, setActiveTab] = useState('list');

    const tabs = [
        { label: 'Conversiones', value: 'list' },
        { label: 'ISBNs', value: 'isbn' },
        { label: 'Portadas', value: 'portadas' }
    ];

    const handleClick = (value) => {
        setActiveTab(value);
        handleTabChange(value);
    }

    return (
        <nav className='products'>
            <ul>
                {tabs.map((tab) => (
                    <li
                        key={tab.value}
                        className={activeTab === tab.value ? 'selected' : ''}
                        onClick={() => handleClick(tab.value)}
                    >
                        {tab.label}
                    </li>
                ))}
            </ul>
        </nav>
    );
}

export default NavConversion;
